import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegexToCheckEMail } from '@bo-client/shared/forms/forms.validators';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { uri } from '@bo-client/shared/constants/uri';
import { ValidatorsService } from '@bo-client/shared/forms/validators.service';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';

@Component({
  selector: 'app-gr-transfer-to-technician',
  templateUrl: './gr-transfer-to-technician.component.html',
  styleUrls: ['./gr-transfer-to-technician.component.scss']
})
export class GrTransferToTechnicianComponent
  implements
    CustomFormComponent<
      GridRegistrationModel,
      {
        additionalData: string;
        comment: string;
      }
    >,
    OnInit
{
  @Input() data: DataForCustomFormModel<GridRegistrationModel>;
  @Output() onConfirm: EventEmitter<{
    additionalData: string;
    comment: string;
  }> = new EventEmitter();

  public model: GridRegistrationModel;
  public currentForm: FormGroup;
  public comment = '';
  public eMailExists = true;

  constructor(
    private fb: FormBuilder,
    private httpHapService: HttpHapService,
    public validatorsService: ValidatorsService
  ) {}

  ngOnInit(): void {
    this.model = this.data.model;
    this.currentForm = this.fb.group({
      email: [null, [Validators.required, Validators.pattern(RegexToCheckEMail)]],
      comment: [null]
    });
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  checkEMail() {
    this.eMailExists = true;
    this.httpHapService
      .get(uri.userExistsForCurrentMandant + '/' + this.currentForm.get('email').value)
      .subscribe((x) => {
        this.eMailExists = x;
        if (this.eMailExists) {
          this.onConfirm.emit({
            additionalData: this.currentForm.get('email').value,
            comment: this.currentForm.get('comment').value
          });
        }
      });
  }

  confirm() {
    if (this.currentForm.valid) {
      this.checkEMail();
    }
  }
}
